/**
 * React hook that is used to mark the block wrapper element.
 * It provides all the necessary props like the class name.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/packages/packages-block-editor/#useblockprops
 */
import { RichText, useBlockProps} from '@wordpress/block-editor';

import { flattenIconsArray,parseIcon } from '../icon/utils';
import getIcons from '../icon/icons';
import { bolt as defaultIcon } from '../icon/icons/bolt';

/**
 * The save function defines the way in which the different attributes should
 * be combined into the final markup, which is then serialized by the block
 * editor into `post_content`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-edit-save/#save
 *
 * @return {WPElement} Element to render.
 */

export default function Save({ attributes }) {
	const isEmpty = (value) => {
		if (value == null) return true; // null or undefined
		if (typeof value === 'string' || Array.isArray(value)) return value.length === 0;
		if (typeof value === 'object') return Object.keys(value).length === 0;
		return false; // numbers, booleans, functions, etc.
	};


	const blockProps = useBlockProps.save({
		// id: attributes.uniqueID,
		className:`th-button-wrapper${attributes.uniqueID}`
	  });

	  const hasLink = attributes.post && attributes.post.url;

	  // advance animation calss
	  const animationClass = attributes?.advAnimation?.className || '';
  	

	  const hoverAnimationClass = animationClass.trim();

	  const effectClass = attributes.animationData?.background?.value || 'none';
  	  const effectTrigger = attributes.animationData?.background?.type || 'onhvr';
	  
	  const buttonClasses = `th-button th-button-inside ${hoverAnimationClass} ${effectClass} effect-trigger-${effectTrigger} ${
		effectClass !== 'none' ? effectClass : ''
	  } ${animationClass}`.trim();

	  let variablestyle = {
		...(attributes.animationData && { '--animation-box-button': attributes.animationData?.background?.bg }),
		...(attributes.color && { '--button-color': attributes.color }),
		...(attributes.hoverColor && { '--button-hvr-color': attributes.hoverColor }),
		...(attributes.btnBackground && { '--button-background': attributes.btnBackground.color }),
		...(attributes.btnBackground && { '--button-gradient': attributes.btnBackground.gradient }),
		...(attributes.btnBackgroundHover && { '--button-hvr-background': attributes.btnBackgroundHover.color }),
		...(attributes.btnBackgroundHover && { '--button-hvr-gradient': attributes.btnBackgroundHover.gradient }),
		...(attributes.btnBorder && { '--btnBorder-width': attributes.btnBorder.Desktop.top.width }),
		...(attributes.btnBorder && { '--btnBorder-color': attributes.btnBorder.Desktop.top.color }),
		...(attributes.btnBorderHover && { '--btnBorderHover-color': attributes.btnBorderHover.Desktop.color }),
	}

	const mergedStylesbutton = {
		...variablestyle,
	};

    const blockPropsButton = {
        className: buttonClasses,
        href: hasLink ? attributes.post.url : '#', // Safe default
        target: hasLink && attributes.post.opensInNewTab ? '_blank' : '_self', // Default target value
        rel: hasLink && attributes.post.markAsNofollow ? 'nofollow noreferrer noopener' : '', // Default rel value
		style: mergedStylesbutton,
	};

		// Vayu Icon Rendering
const { icon, iconName, iconToggle} = attributes;

const iconsAll = flattenIconsArray( getIcons() );
const namedIcon = iconsAll.filter( ( i ) => i.name === iconName );
let customIcon = defaultIcon;

if ( icon && isEmpty( namedIcon ) ) {
	customIcon = parseIcon( icon );

	if ( isEmpty( customIcon?.props ) ) {
		customIcon = defaultIcon;
	}
}

let printedIcon = ! isEmpty( namedIcon ) ? namedIcon[ 0 ].icon : customIcon;

// Icons provided by third-parties are generally strings.
if ( typeof printedIcon === 'string' ) {
	printedIcon = parseIcon( printedIcon );
}

// Markup for the icon
const iconMarkup = (
	<>
		{ ! icon && ! iconName ? (
			<IconPlaceholder
				setInserterOpen={ setInserterOpen }
				isQuickInserterOpen={ isQuickInserterOpen }
				setQuickInserterOpen={ setQuickInserterOpen }
				isCustomInserterOpen={ isCustomInserterOpen }
				setCustomInserterOpen={ setCustomInserterOpen }
				attributes={ attributes }
				setAttributes={ setAttributes }
				enableCustomIcons={ enableCustomIcons }
				isSVGUploadAllowed={ isSVGUploadAllowed }
			/>
		) : (
			<div
				className={`vayu_blocks_icon_block_main_icon_svg`}
				
			>
				{	printedIcon }

			</div>
		) }
	</>
);


 // Conditionally render <a> or <span>
 const linkElement = hasLink ? (
	<a {...blockPropsButton}>
		{iconToggle && <span className="vayu-icon">{iconMarkup}</span>}
			<RichText.Content
				tagName="span"
				value={attributes.content}
				className="vayu-btn-text"
			/>
	</a>
) : (
	<div className={buttonClasses} style={mergedStylesbutton}>
		{iconToggle && <span className="vayu-icon">{iconMarkup}</span>}
			<RichText.Content
				tagName="span"
				value={attributes.content}
				className="vayu-btn-text"
			/>
	</div>
);

	return (
		<div {...blockProps}>
            {linkElement}
        </div>
	);
}
